// extracted by mini-css-extract-plugin
export default {"full_size":"Report_full_size__3Dh3e","loading":"Report_loading__fZKrF","search":"Report_search__R6O8F"};